import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VBtn,{on:{"click":_vm.executeExport}},[_vm._v(_vm._s(this.$t("ctrl.export")))])
}
var staticRenderFns = []

export { render, staticRenderFns }